
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/uxui-improvement",
      function () {
        return require("private-next-pages/cases/uxui-improvement/index.tsx");
      }
    ]);
  